export enum TaskAnalysisState {
  StartableBest = "StartableBest",
  Startable = "Startable",
  StartedBest = "StartedBest",
  Started = "Started",
  UnstartableDependent = "UnstartableDependent",
  UnstartableNoRoute = "UnstartableNoRoute",
  Impossible = "Impossible",

  /* deprecated states to be removed */
  Completed = "Completed",
  Irrelevant = "Irrelevant",
  Canceled = "Canceled",
  StartableLate = "StartableLate",
  UnstartableLate = "UnstartableLate",
}
